/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconInfoFilled12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconInfoFilled12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 1a5 5 0 1 0 0 10A5 5 0 0 0 6 1Zm0 3.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm.625.752V9h-1.25V5.002h1.25Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconInfoFilled16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconInfoFilled16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 1.333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 8 1.334Zm0 4.334a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm.833 1.003V12H7.166V6.67h1.667Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconInfoFilled20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconInfoFilled20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 1.667a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 0 0 0-16.666Zm0 5.416a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm1.042 1.254V15H8.959V8.337h2.083Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconInfoFilled24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconInfoFilled24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm1.25 1.505V18h-2.5v-7.995h2.5Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconInfoFilled = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconInfoFilled(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '12':
            return <IconInfoFilled12 {...iconProps} />;
        case '16':
            return <IconInfoFilled16 {...iconProps} />;
        case '20':
            return <IconInfoFilled20 {...iconProps} />;
        case '24':
            return <IconInfoFilled24 {...iconProps} />;
        default:
            return <IconInfoFilled24 {...iconProps} />;
    }
});
